import React, { useState } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import styles from './customSecondaryCheckBox.module.scss';

export const CustomSecondaryCheckBox = (props) => {
    const [isChecked, setIsChecked] = useState(props.ischecked);
    return (
        <div className={`${styles.defaultCheckBoxMain} ${isChecked ? styles.isCheckedCheckBoxMain : ''}`} id={props.controlId}>
            <div className='d-flex flex-row'>
                <div className={`${styles.svgDiv} ${isChecked ? styles.isCheckedSvgDiv : ''}`}>
                    {React.cloneElement(props.svg, { stroke: isChecked ? '#2DA6C0' : '#475467' })}
                </div>

                <div className={styles.checkBoxTitle}>
                    {props.label}
                </div>
            </div>

            <div className={styles.checkBoxMain}>
                <input className={styles.checkboxInput}
                    checked={isChecked}
                    id={props.id}
                    onChange={() => {
                        setIsChecked((prev) => !prev);
                        props.handleOnChange(); // Call the handleOnChange function from props
                      }}
                    type="checkbox"
                    value={props.value}
                    />
                    {isChecked && (
                <svg
                    className={styles.checkboxIcon}
                    width="10"
                    height="7"
                    viewBox="0 0 10 7"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M8.33329 1L3.74996 5.58333L1.66663 3.5"
                        stroke="white"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )}
                    
            </div>
        </div>
    )
}